'use client';

import { colors } from '../Utils/constants.js';

var DEFAULT_OPTIONS = {
    radius: 102,
    strokeWidth: 6,
    color: colors.primaryColor,
    label: {
        size: 24,
        weight: 700,
        lineHeight: 29,
        extend: ''
    },
    segmentSpace: 10,
    pieceCount: 4,
    duration: 1000 // Duration in milliseconds
};

export { DEFAULT_OPTIONS };
//# sourceMappingURL=constants.js.map
